<template>
	<div>
		<!-- 循环渲染每组内容 -->
		<div style="padding: 10px 0;">
			<div v-for="(item, idx) in imageList" :key="idx"
			style="margin-bottom: 16px; border: 1px solid #e8e8e8; padding: 12px; border-radius: 4px; position: relative;">
			<!-- 删除该视频项 -->
			<a-icon type="close-circle"
				style="position: absolute; top: 8px; right: 8px; font-size: 20px; color: #f5222d; cursor: pointer; z-index: 10;"
				@click="deleteItem(idx)" />
				<!-- 视频描述 -->
				<a-form layout="inline" style="margin-bottom: 8px;">
					<a-form-item label="视频描述">
						<a-input v-model="item.brandLine" placeholder="请输入视频描述" style="width: 200px"
							@input="syncParent" />
					</a-form-item>
				</a-form>

				<!-- 视频封面 独立ref -->
				<a-form layout="inline" style="margin-bottom: 8px;">
					<a-form-item label="视频封面">
						<div>
							<div style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center;">
								<div v-if="item.factoryImages" style="position: relative;">
									<viewer :images="[item.factoryImages]">
									<img :src="item.factoryImages" style="width: 80px; height: 80px; object-fit: cover;">
								</viewer>
									<div style="position: absolute; top: -8px; right: -8px; background: red; color: white;
                  width: 20px; height: 20px; border-radius: 50%; text-align: center;
                  line-height: 18px; cursor: pointer;" @click="delCover(item)">×</div>
								</div>

								<!-- 图片上传 input 独立 ref -->
								<input type="file" accept=".jpg,.jpeg,.png" @change="handleFile($event, item, idx)"
									style="display: none;" :ref="'img_file_' + idx" />
								<div v-if="coverLoading[idx]" style="width: 80px; height: 80px; border: 1px dashed #ccc;
                display: flex; align-items: center; justify-content: center;">
									<a-icon type="loading" style="font-size: 24px; color: #1890ff;" />
								</div>
								<div v-else @click="$refs['img_file_' + idx][0].click()" style="width: 80px; height: 80px; border: 1px dashed #ccc;
                display: flex; align-items: center; justify-content: center; cursor: pointer;">
									<a-icon type="plus" />
								</div>
							</div>
							<div style="color: #999; font-size: 12px; margin-top: 4px;">只能上传jpg/png格式文件，单文件不能超过3M</div>
						</div>
					</a-form-item>
				</a-form>

				<!-- 视频地址/视频上传 独立ref -->
				<a-form layout="inline">
					<a-form-item label="视频地址">
						<div>
							<div style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center;">
								<div v-if="item.factoryVideo" style="position: relative;">
									<video :src="item.factoryVideo" style="width: 80px; height: 80px; object-fit: cover;"
										controls></video>
									<div style="position: absolute; top: -8px; right: -8px; background: red; color: white;
                  width: 20px; height: 20px; border-radius: 50%; text-align: center;
                  line-height: 18px; cursor: pointer;" @click="delVideo(item)">×</div>
								</div>

								<!-- 视频上传 input 独立 ref -->
								<input type="file" accept=".mp4" @change="handleVideo($event, item, idx)"
									style="display: none;" :ref="'video_file_' + idx" />
								<div v-if="videoLoading[idx]" style="width: 80px; height: 80px; border: 1px dashed #ccc;
                display: flex; align-items: center; justify-content: center;">
									<a-icon type="loading" style="font-size: 24px; color: #1890ff;" />
								</div>
								<div v-else @click="$refs['video_file_' + idx][0].click()" style="width: 80px; height: 80px; border: 1px dashed #ccc;
                display: flex; align-items: center; justify-content: center; cursor: pointer;">
									<a-icon type="plus" />
								</div>
							</div>
							<div style="color: #999; font-size: 12px; margin-top: 4px;">只能上传mp4格式文件，文件不能超过10M</div>
						</div>
					</a-form-item>
				</a-form>
			</div>

			<!-- 添加项按钮 -->
			<a-button type="primary" @click="addItem" style="margin-top: 10px;">
				+ 添加项（视频）
			</a-button>
		</div>

	</div>
</template>

<script>
	import {
		ossUpload
	} from "../../../utils/oss";
	export default {
		props: {
			errors: {
				type: Array,
				default: () => []
			},
			value: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				imageList: [],
				coverLoading: {},
				videoLoading: {}
			};
		},
		watch: {
			value: {
				deep: true,
				immediate: true,
				handler(val) {
					this.imageList = val.map(item => ({
						factoryEnvironmentId: item.factoryEnvironmentId || null,
						factoryLangId: item.factoryLangId || null,
						brandLine: item.brandLine || '',
						factoryImages: item.factoryImages || '',
						factoryVideo: item.factoryVideo || '',
						factoryEnvironmentType: 'VIDEO',
					}));
				}
			}
		},
		methods: {
			// 新增一组
			addItem() {
				this.imageList.push({
					factoryEnvironmentId: null,
					factoryLangId: null,
					brandLine: '',
					factoryImages: '',
					factoryVideo: "",
					factoryEnvironmentType: 'VIDEO'
				});
				this.syncParent();
			},

			// 删除整个视频项
			deleteItem(idx) {
				this.imageList.splice(idx, 1);
				this.syncParent();
			},

			// 删除封面图片
			delCover(item) {
				item.factoryImages = '';
				this.syncParent();
			},

			// 删除视频
			delVideo(item) {
				item.factoryVideo = '';
				this.syncParent();
			},

			// 图片上传（封面，仅限jpg/png，最大3M）
			async handleFile(e, item, idx) {
				if (!e.target.files.length) return;
				const file = e.target.files[0];
				const ext = file.name.split('.').pop().toLowerCase();
				if (!['jpg', 'jpeg', 'png'].includes(ext)) {
					this.$message.warning('只能上传jpg/png格式文件');
					e.target.value = '';
					return;
				}
				if (file.size > 3 * 1024 * 1024) {
					this.$message.warning('图片大小不能超过3M');
					e.target.value = '';
					return;
				}
				this.$set(this.coverLoading, idx, true);
				ossUpload(file, '', 'image/')
					.then((res) => {
						item.factoryImages = res.url;
						this.syncParent();
						e.target.value = "";
						this.$set(this.coverLoading, idx, false);
					})
					.catch(() => {
						this.$message.error('图片上传失败');
						this.$set(this.coverLoading, idx, false);
					});
			},

			// 视频上传（仅限mp4，最大10M）
			async handleVideo(e, item, idx) {
				if (!e.target.files.length) return;
				const file = e.target.files[0];
				const ext = file.name.split('.').pop().toLowerCase();
				if (ext !== 'mp4') {
					this.$message.warning('只能上传mp4格式文件');
					e.target.value = '';
					return;
				}
				if (file.size > 10 * 1024 * 1024) {
					this.$message.warning('视频大小不能超过10M');
					e.target.value = '';
					return;
				}
				this.$set(this.videoLoading, idx, true);
				ossUpload(file, '', 'video/')
					.then((res) => {
						item.factoryVideo = res.url;
						this.syncParent();
						e.target.value = "";
						this.$set(this.videoLoading, idx, false);
					})
					.catch(() => {
						this.$message.error('视频上传失败');
						this.$set(this.videoLoading, idx, false);
					});
			},

			// 同步数据到父组件
			syncParent() {
				const result = this.imageList.map(item => ({
					factoryEnvironmentId: item.factoryEnvironmentId,
					factoryLangId: item.factoryLangId,
					brandLine: item.brandLine,
					factoryImages: item.factoryImages,
					factoryVideo: item.factoryVideo,
					factoryEnvironmentType: 'VIDEO'
				}));
				this.$emit("input", result);
			}
		}
	};
</script>
